module.exports = __webpack_public_path__ + "img/2.3.b52f6d80.png";